'use client';

import type { Content } from '@prismicio/client';
import { FC, JSX, useRef, useState } from 'react';

import { useOutsideClick } from '@/hooks';
import { ListItem } from '../../ListItem/ListItem';

import { useMenuState } from '@/context/headerContext';
import {
  NavigationHeading,
  NavigationHeadingProps,
} from '../../NavigationHeading/NavigationHeading';
import styles from './mobileMenu.module.scss';

type Props = {
  slice: Content.NavigationSlice;
};

export const MobileMenu: FC<Props> = ({ slice }): JSX.Element => {
  const { toggleMenu } = useMenuState();
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  const closeMenu = () => setIsOpenMenu(false);

  const menuRef = useOutsideClick<HTMLLIElement>(closeMenu);

  const contentHeightRef = useRef<HTMLUListElement | null>(null);

  const isDropDownMenu = slice.primary.drop_down_links.length > 0;

  const navigationHeadingProps: NavigationHeadingProps = {
    heading: slice.primary.heading,
    isDropDownMenu,
    link: slice.primary.link,
    iconStyle: isOpenMenu ? styles.icon_style : '',
  };

  const handleOnClick = () => {
    setIsOpenMenu((prev) => !prev);

    if (!isDropDownMenu) toggleMenu();
  };

  // eslint-disable-next-line react-hooks/refs
  const contentHeight = contentHeightRef.current
    ? contentHeightRef.current.scrollHeight
    : 0;
  const listAccordionStyle = isOpenMenu
    ? {
        // eslint-disable-next-line react-hooks/refs
        height: contentHeight,
        opacity: 0.6,
      }
    : {};

  return (
    <li
      ref={menuRef}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.navigation_wrapper}
      onClick={handleOnClick}
    >
      <NavigationHeading {...navigationHeadingProps} />
      {isDropDownMenu ? (
        <ul
          ref={contentHeightRef}
          className={`${styles.navigation_list} ${isOpenMenu ? styles.isOpen : ''}`}
          // eslint-disable-next-line react-hooks/refs
          style={listAccordionStyle}
        >
          {slice.primary.drop_down_links.map((item, index) => {
            const tabs = 'scroll_to_products_information' in item;
            const isActiveTab = tabs && item.scroll_to_products_information;
            return (
              <ListItem
                scrollToSectionNumber={item.scroll_to_section_number ?? null}
                key={item.title}
                title={item.title}
                activeTab={isActiveTab ? index : undefined}
                link={item.link}
              />
            );
          })}
        </ul>
      ) : null}
    </li>
  );
};
